import actions from '@/store/modules/notifications/actions.js'
import getters from '@/store/modules/notifications/getters.js'
import mutations from '@/store/modules/notifications/mutations.js'
import getDefaultState from '@/store/modules/notifications/state.js'

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}
